import React, {Component} from 'react';
import CombinationsBox from './components/combinations-box';
import Dashboard from './components/mobile/dashboard';
import {connect} from 'react-redux';

class KeyPlayerCombinations extends Component {
    canComponentBeRendered() {
        const {comboGroups} = this.props;

        return comboGroups.hasAnyGroups();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        return (
            <div className="tab-content stack-combinations-content">
                <Dashboard />
                <CombinationsBox />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        keyPlayerStacking: {combinations},
    } = state;

    return {
        comboGroups: combinations.groups,
    };
}

const KeyPlayerCombinationsComponent = connect(mapStatesToProps)(KeyPlayerCombinations);

export {KeyPlayerCombinationsComponent};
